import React, {forwardRef, useImperativeHandle, useRef} from "react"

import IatRecorder from "./iatRecorder"
import Styles from "./radioIcon.less"
import isEmpty from "lodash-es/isEmpty"
import {useMount, useUnmount} from "ahooks"
import {Lottie} from "@crello/react-lottie"

import defaultAnimation from "./default-animation.json"
import activeAnimation from "./active-animation.json"
import exitImg from "./image/语音输入叉叉.png"
import useRadioActive from "./share/useRadioActive"
import useRadioError from "./share/useRadioError"
import useCurrentRobotInput from "../Input/share/useCurrentRobotInput"

interface RadioIconProps {
    onTextChange?: (e: string, obj: StatusProps) => void
}

export interface StatusProps {
    old: StatusType
    new: StatusType
}

export enum StatusType {
    INIT = "init",
    ING = "ing",
    END = "end",
}

export interface RadioRefObj {
    onStopRecording: () => void
    onClick: () => void
}

const RadioIcon: React.FC<RadioIconProps> = ({onTextChange}, ref) => {
    const recoderRef = useRef<any>(null)

    // const asrConfig = useSelector((state: ReduxStore) => state.search.Asr)

    const statusRef = useRef<StatusProps>({
        old: StatusType.INIT,
        new: StatusType.INIT,
    })

    const radioActive = useRadioActive()
    const radioError = useRadioError()
    useMount(() => {
        const config = {
            language: "zh_cn",
            accent: "mandarin",
            // asrConfig: asrConfig,
            asrConfig: null,

            onWillStatusChange: (oldStatus: StatusType, newStatus: StatusType) => {
                statusRef.current = {
                    old: oldStatus,
                    new: newStatus,
                }
                if (newStatus === StatusType.END) {
                    radioActive.toFalse()
                }
            },
            onTextChange: (text: string) => {
                // console.log(text)
                onTextChange && onTextChange(text, statusRef.current)
            },
            onInitError: (e: any) => {
                if (e.name === "NotFoundError") {
                    console.error("没有找到麦克风")
                    radioError.setMessage("没有找到麦克风")
                } else if (e.name === "NotAllowedError") {
                    console.error("获取麦克风权限失败，请重新检查许可")
                    radioError.setMessage("获取麦克风权限失败，请重新检查许可")
                } else {
                    console.error("语音转文字功能遇到了问题", e.name)
                    radioError.setMessage(e.message)
                }
                radioActive.toFalse()
                radioError.toTrue()
                setTimeout(() => {
                    radioError.toFalse()
                }, 3000)
            },
        }
        recoderRef.current = new IatRecorder(config)
    })

    useUnmount(() => {
        recoderRef.current.destory()
    })

    useImperativeHandle<RadioRefObj, RadioRefObj>(ref, () => ({
        onStopRecording: handStopRecording,
        onClick: handleBtnClick,
    }))

    const handStopRecording = () => {
        radioActive.toFalse()
        recoderRef.current.stop()
    }

    const handleBtnClick = () => {
        if (radioError.value) {
            return
        }

        radioActive.reverse()

        let iatRecorder = recoderRef.current
        if (iatRecorder.status === StatusType.ING) {
            iatRecorder.stop()
        } else {
            iatRecorder.start()
        }
    }

    const currentInputText = useCurrentRobotInput()[0]

    const getAnimationSource = () => {
        let status = (statusRef.current as StatusProps).new
        const activeFlag = radioActive.value

        let src: any = defaultAnimation

        // console.log(status, activeFlag, currentInputText)

        //  点击了录音，且没有说话，视之为Img激活状态
        if (activeFlag && isEmpty(currentInputText)) {
            return activeAnimation
        }
        if (activeFlag && status === StatusType.ING) {
            src = activeAnimation
        }
        if (status === StatusType.END) {
            src = defaultAnimation
        }
        if (radioError.value === true) {
            src = defaultAnimation
        }
        return src
    }

    let currentSearchInput = useCurrentRobotInput()[0]
    const getShowText = () => {
        if (radioError.value === true) {
            return <span style={{color: "#7F93BC"}}>{radioError.message}</span>
        }
        if (currentSearchInput == null || currentSearchInput.length === 0) {
            return <span style={{color: "#7F93BC"}}>请说，我正在听</span>
        }
        return currentSearchInput
    }

    const handleExitClick = () => {
        let iatRecorder = recoderRef.current
        iatRecorder.stop()
    }

    return (
        <div className={Styles["new-radio-wrapper"]}>
            <img className={Styles["exit"]} onClick={handleExitClick} src={exitImg} alt={"exit"} />
            <div className={Styles["radio-input-text"]}>{getShowText()}</div>
            <div className={Styles["radio-animation-wrapper"]} onClick={handleBtnClick}>
                <Lottie
                    width="84px"
                    height="84px"
                    config={{animationData: getAnimationSource(), loop: true, autoplay: true}}
                />
            </div>
        </div>
    )
}

// @ts-ignore
export default forwardRef(RadioIcon)
